<template>
    <div class="classRoomManagement padding-x-y ">
        <!--修改班级名称-->
        <common-dialog
                @closeDialog="closeDialogChangeClass"
            :dialog-show="changClassDialog"
            :model-obj="changeClassData">
            <div name="title" class="margin-left text-left font-weight-bolder text-l-size">
                {{titleUpdate}}
            </div>
            <div class="padding" v-show="titleUpdate==='修改班级名称'">
                <el-form style="width:450px;" label-width="100px" class="m-auto">
                    <el-form-item label="所属学校 ">
                        <div>{{schoolName}}</div>
                        <div class="text-s-size text-small-secondary">如果学校名称有误，请联系致电 <span style="color: #00a1ff;">4000127985</span></div>
                    </el-form-item>
                    <el-form-item label="所属年级">{{gradeName}}</el-form-item>
                    <el-form-item label="班级名称">
                        {{gradeName+'( '}}
                        <el-input style="width:130px;" size="small" placeholder="请填写班级号" v-model="classValue"></el-input>
                        ）班
                    </el-form-item>
                    <div class="text-right">
                        <el-button size="small" class="margin-medium-right" @click="changClassDialog=false,classValue=''">取消</el-button>
                        <el-button size="small" @click="confirmChangeClass"  type="primary">确定</el-button>
                    </div>
                </el-form>
            </div>
            <div  style="padding:30px 30px 40px 90px;" v-show="titleUpdate==='批量修改班级-加班设置'">
                <div>学生加班设置:</div>
                <div class="margin-top">
                    <el-radio-group v-model="joinClassVal">
                        <el-radio v-for="item in allowUserJoinValues"
                                  :key="item.allowUserJoinValue"
                                  :label="item.allowUserJoinValue">
                            {{item.text}}
                        </el-radio>
                    </el-radio-group>
                </div>
                <div class="margin-medium-top text-right">
                    <el-button size="small" class="margin-right" @click="joinClassVal='' , changClassDialog=false">取消</el-button>
                    <el-button size="small" type="primary" @click="selectJoinClassBatchSetting">确定</el-button>
                </div>
            </div>
            <div class="padding" v-show="titleUpdate==='批量修改班级-学生改名设置'">
                <div>
                    学生改名设置:
                </div>
                <div class="margin-top">
                    <el-radio-group v-model="updateName">
                        <el-radio v-for="item in allowChangeNames"
                                  :key="item.allowStudentChangeValue"
                                  :label="item.allowStudentChangeValue">
                            {{item.text}}
                        </el-radio>
                    </el-radio-group>
                </div>
                <div class="text-right margin-top">
                    <el-button size="small" class="margin-right" @click="updateName='' , changClassDialog=false">取消</el-button>
                    <el-button size="small" @click="batchOperateStudentChangeName" type="primary">确定</el-button>
                </div>
            </div>
        </common-dialog>
        <!--批量修改班级-加班设置-->
        <div class="border-bottom padding-b">
            <el-button type="text" size="mini">
                <span class="text-l-size text-default-color">班级管理</span>
            </el-button>
            <div class="float-right">
                <el-tooltip content="Bottom center" placement="bottom" effect="light">
                    <div slot="content">
                        行政班：跟学校的班级组织结构一致的班级被称为行政班。行政班里面包含班主任、学科老师。<br/>
                        教学班：为适应新高考走班制推出的教学班，科任老师可以根据学校的走班情况创建自己所教授的学科的教学班。
                    </div>
                    <el-button type="text">
                        <span class="iconfont icon-xingzhuang vertical-middle margin-right " style="color:#A0BCFF;font-size:23px;"></span>
                    </el-button>
                </el-tooltip>
                <el-button size="small" plain type="primary" @click="addAdministrationClass">加入行政班</el-button>
                <el-button size="small" plain type="primary" @click="createClassroom">创建教学班</el-button>
            </div>
        </div>
        <div class="margin-top">
            <el-input size="small" placeholder="请输入班级名称 搜索" class="margin-medium-x" @keyup.enter.native="searchBtn" v-model="searchValue"></el-input>
            <el-button size="small" @click="searchBtn" type="primary"><span class="text-white">搜索</span> </el-button>
            <span class="text-small-secondary margin-medium-x">班级类型</span>
            <el-select size="small" v-model="classroomValue" @change="selectClassType"   placeholder="请选择" >
                <el-option
                        v-for="item in classroomList"
                        :key="item.classType"
                        :label="item.classTypeName"
                        :value="item.classType">
                </el-option>
            </el-select>
            <span class="text-small-secondary margin-medium-x">所属年级</span>
            <el-select size="small" v-model="gradeValue" placeholder="请选择"  @change="selectGrade">
                <el-option
                        v-for="item in gradeList"
                        :key="item.gradeYear"
                        :label="item.gradeName"
                        :value="item.gradeYear">
                </el-option>
            </el-select>
        </div>
        <div style="line-height: 34px;" class="margin-medium-y">
            <span class="text-small-secondary">共<span style="color:#ff9631;">{{classCount}}</span>个班级</span>
            <div class="float-right">
                <span class="text-small-secondary margin-right">批量操作:</span>
                <el-button :disabled="batchSettingDisabled" class="" @click="openClassJoin" size="small">学生加班设置</el-button>
                <el-button :disabled="batchSettingDisabled" class="" @click="openUpdateName" size="small">学生改名设置</el-button>
            </div>
        </div>
        <el-table  :cell-style="{'text-align':'center'}"
                   :data="classroomTableData"
                   stripe
                   @selection-change="handleSelectionChange"
                  :headerCellStyle="{
                    background:'#FAFAFA',
                    fontWeight: 'bolder',
                    color: '#666666',
                    textAlign: 'center'}"
                  :loading="loading">
            <el-table-column   type="selection" width="55">
            </el-table-column>
            <el-table-column label="班级名称" prop="className">
            </el-table-column>
            <el-table-column label="班级类型" prop="classTypeId">
            </el-table-column>
            <el-table-column label="所属年级" prop="graduateStr">
            </el-table-column>
            <el-table-column label="学生人数" prop="stuNum">
            </el-table-column>
            <el-table-column label="班主任" prop="headTeacherName">
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="lookClassDetail(scope.row)">详情</el-button>
                    <el-button :disabled="!scope.row.canEdit" type="text" @click="updateClassName(scope.row)">修改名称</el-button>
                </template>
            </el-table-column>
            <el-table-column
                    prop=""
                    width="200px"
                    >
                <template slot="header" slot-scope="scope">
                    <div>
                        <span>
                            学生加班设置
                        </span>
                        <el-tooltip placement="left" effect="light">
                            <div slot="content">
                                禁止学生自主加班，是禁止所有学生加入到某个班级中，防止学生重复添加，造成班级管理混乱；<br>
                                禁止注册用户加班，是禁止注册用户加入到班级，防止部分学生重复注册账号加入到班级。
                           </div>
                            <el-button class="el-icon-question" size="medium" type="text"></el-button>
                        </el-tooltip>

                    </div>
                </template>
                <template slot-scope="scope">
                    <div class="  tableSelect">
                        <el-select size="small" :disabled="!scope.row.canEdit"  style="width: 100px;" v-model="scope.row.allowUserJoinValue" @change="selectJoinClassSetting(scope.row.allowUserJoinValue,scope.row.id)"   placeholder="请选择" >
                            <el-option
                                    v-for="item in getJoinClassSettingList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                    prop="studentChangeName"
                    label="允许学生改名">
                <template slot="header">
                    <div>
                        <span>允许学生改名</span>
                        <el-tooltip placement="left" effect="light">
                            <div slot="content">
                                禁止学生改名，是防止班级学生姓名完好情况下，学生再私自改名无法辨认。
                            </div>
                            <el-button class="el-icon-question" size="medium" type="text"></el-button>
                        </el-tooltip>
                    </div>
                </template>
                <template slot-scope="scope">
                    <el-switch
                            :disabled="!scope.row.canEdit"
                            @change="studentSignUpdateName(scope.row.id,scope.row.allowStudentChangeValue)"
                            v-model="scope.row.allowStudentChangeValue"
                            active-text="开"
                            inactive-text="关">
                    </el-switch>
                </template>
            </el-table-column>
        </el-table>
        <!-- 是否调用分页 -->
        <el-pagination
                class="text-right"
                style="padding:30px 50px 0 0;"
                       layout="total, prev, pager, next, jumper"
                       :page-size="pageObj.size"
                       :total="pageObj.total"
                       :current-page.sync="pageObj.currentPage"
                       @current-change="handlerPage">
        </el-pagination>
        <coassRoomManagementSon></coassRoomManagementSon>
        <loading :show="loading"></loading>
        <common-create-class @searchClassroomList="searchClassroomList" ref="commonCreateClass">
        </common-create-class>
    </div>
</template>
<script>
    /*问题当选择班级中的职位添加的时候，发现无法添加职位*/
    import commonCreateClass from './components/commonCreateClass';
    import coassRoomManagementSon from './coassRoomManagementSon';
    import {
        batchOperateBaseData, batchOperateJoinValue, batchOperateStudentChangeValue,
        classUpdate,
        stuClassAdminClassDetail,
        stuClassAdminGrades,
        stuClassAdminSchool,
        stuClassAdminType
    } from "../../../config";
    import {mapActions,mapState} from 'vuex'
    export default {
        name: "classRoomManagement",
        components:{
          coassRoomManagementSon,
          commonCreateClass
        },
        data(){
            return{
                titleUpdate:'',
                //控制学生加班设置，学生改名批量设置与否
                batchSettingDisabled:true,
                //获取点击班级查出的班级详情
                gradeName:'',
                //点击修改名称获取班级名称
                selectClassName:'',
                //接收修改的班级名称
                classValue:'',
                changClassDialog:false,
                changeClassData:{
                  title:'',
                  width:'550px',
                  center:false
                },
                //判断正整数
                regZzNum:'',
                searchValue:'',
                dialogModelObj:{
                  width:"708px",
                  title:'创建班级'
                },
                srcc:'https://sslvzhoustatic.oss-cn-beijing.aliyuncs.com/test/jxzx.png',
                fieldList:[
                    {slot:'多选'},
                    {label:'班级名称',prop:'className'},
                    {label:'班级类型',prop:'classTypeId'},
                    {label:'所属年级',prop:'graduateStr'},
                    {label:'学生人数',prop:'stuNum'},
                    {label:'班主任',prop:'headTeacherName'},
                    {slot:'操作'},
                    {slot:'下拉选框'},
                    {slot:'switch'}
                ],
                pageObj:{
                    size:20,
                    total:0,
                    currentPage:1,
                    func:'func'
                },
                headerCellStyle:{
                    background: '#e8ffe9',
                    color: '#666666',
                    fontWeight: 'bolder',
                    textAlign: 'center',
                },
                loading:false,
                createTeachingDialogVisible:false,
                //改名
                nameChangeAllowed:'开',
                //班级表格的数据
                classroomTableData:[],
                //班级数量
                classCount:0,
                classroomValue:'',
                classroomList:[],
                gradeValue:0,
                gradeList:[],
                currentPage:1,
                totalItem:0,
                /******修改班级******/
                classId:'',
                //获取批量操作学生加班设置选项内容
                allowUserJoinValues:[],
                joinClassVal:'',
                //获取批量操作学生改名设置选项内容
                allowChangeNames:[],
                //获取改名所选的值
                updateName:'',
                //获取批量选中的班级id
                classIdList:[],
                //获取加班设置列表
                getJoinClassSettingList:[
                    {
                        value:1,
                        label:'不限制'
                    },
                    {
                        value:2,
                        label:'禁止学生自主加班'
                    },
                ]
            }
        },
        computed:{
          ...mapState(['schoolId','schoolName'])
        },
        mounted(){
            this.searchGradeList();
            this.batchOperateBaseData();
        },
        methods:{
            lookClassDetail(val){
                this.$router.push({path:'/teacher/classes-detail',
                    query:{param:btoa(encodeURIComponent(JSON.stringify(val)))}});
            },
            //获取学生改名加班设置批量操作的基本信息
            async batchOperateBaseData(){
               let result=await batchOperateBaseData();
               if(result.status){
                   this.allowUserJoinValues=result.data.allowUserJoinValues;
                   this.allowChangeNames=result.data.allowChangeNames;
               }
            },
            openUpdateName(){
                this.changClassDialog=true;
                this.titleUpdate='批量修改班级-学生改名设置';
            },
            //打开学生加班设置弹窗
            openClassJoin(){
                this.changClassDialog=true;
                this.titleUpdate='批量修改班级-加班设置';
            },
            //关闭窗口
            closeDialogChangeClass(){
                this.changClassDialog=false;
            },

            //确定修改班级成功，重新查出班级
            async confirmChangeClass(){
                let result=await classUpdate(this.classId,this.classValue);
                if(result.status){
                    this.searchClassroomList();
                    this.changClassDialog=false;
                }else{

                }
            },
            //查出班级名称
            async updateClassName(val){
                this.titleUpdate='修改班级名称';
                this.classId=val.id;
                this.gradeName=val.graduateStr.substr(0, val.graduateStr.indexOf('('));
                let result=await stuClassAdminClassDetail(val.id);
                if(result.status){
                    this.changClassDialog=true;
                    this.selectClassName=result.data.className;
                }
            },
            ...mapActions(['searchSchoolInfo']),
            //创建班级基础内容
            async createClassroom(){
                this.$refs.commonCreateClass.createClassroom(2);
            },

            //搜索按钮进行搜索
            searchBtn(){
                this.currentPage=1;
                this.searchClassroomList();
            },
            //获取年级
            async searchGradeList(){
                this.searchSchoolInfo();
              let result=await stuClassAdminGrades();
              if(result.status){
                  this.gradeList=result.data;
                  this.gradeValue=result.data[0].gradeYear;
                  this.serachClassCategory();
              }else{

              }
            },
            //获取班级类型
            async serachClassCategory(){
              let result=await stuClassAdminType();
              if(result.status){
                this.classroomList=result.data;
                this.classroomValue=result.data[0].classType;
                this.searchClassroomList();
              }
            },
            //班级列表
            async searchClassroomList(){
                this.loading=true;
                let result=await stuClassAdminSchool(this.gradeValue,this.classroomValue,this.searchValue,this.pageObj.currentPage,20);
              if(result.status){
                  this.loading=false;
                  this.classCount=result.data.totalRecords;
                  this.pageObj.total=result.data.totalRecords;
                  this.classroomTableData=result.data.data;
                  for(let i=0;i<this.classroomTableData.length;i++){
                    this.classroomTableData[i].classTypeId=this.classroomTableData[0].classType===1?'行政班':'教学班'
                  }
              }else{
                  this.loading=false;
              }
            },
            closeDialog(){
                this.createTeachingDialogVisible=false;
            },

            //触发分页
            handlerPage(){
                window.scrollTo(0,0);
                this.searchClassroomList();
            },
            addAdministrationClass(){
                this.$router.push('/studentAndTeacherPlatform/schoolManagement/joinadministrativeclass');
            },
            /*表格多选的事件*/
            handleSelectionChange(val){
                this.classIdList=[];
                val.forEach((valSmall)=>{
                    this.classIdList.push(valSmall.id);
                });
                if(val.length>0){
                    this.batchSettingDisabled=false;
                }else{
                    this.batchSettingDisabled=true;
                }
            },
            //学生加班批量设置
            selectJoinClassBatchSetting(){
                this.changClassDialog=false;
                this.commonJoinClassSetting(this.classIdList,this.joinClassVal);
            },
            //学生加班单个设置
             selectJoinClassSetting(val,classId){
                this.commonJoinClassSetting([classId],val);
            },
            //公共使用学生加班设置
            async commonJoinClassSetting(classId,val){
                let result=await batchOperateJoinValue(classId,val);
                if(result.status){
                    this.searchClassroomList();
                }
            },
            //批量设置学生改名
            batchOperateStudentChangeName(){
                this.changClassDialog=false;
                this.commonStudentUpdateNameS(this.classIdList,this.updateName);
            },
            //单个学生改名设置
            studentSignUpdateName(classId,value){
                let updateNameValue=0;
                if(value){
                    updateNameValue=1;
                }
                this.commonStudentUpdateNameS([classId],updateNameValue);
            },
            //公共使用学生改名设置
            async commonStudentUpdateNameS(classIdList,value){
                let result=await batchOperateStudentChangeValue(classIdList,value);
                if(result.status){
                    this.searchClassroomList();
                }
            },
            //
            selectClassType(){
                this.pageObj.currentPage=1;
                this.searchClassroomList();
            },
            selectGrade(){
                this.pageObj.currentPage=1;
                this.searchClassroomList();
            }
        }
    }
</script>
<style lang="scss">
    .classRoomManagement{
        min-height: calc(100vh - 100px);
        margin-top:20px;
        background: #ffffff;
        .el-pagination__jump{
            .el-input{
                width:50px;
            }
        }
        .el-input{
            width:300px;
        }
        .el-select{
            .el-input{
                width:200px;
            }
        }
        .tableSelect{
            .el-select--small{
                width: 100%!important;
            }
            .el-input {
                width:100%;
            }
        }
    }
    .is-plain span:hover{
        color:#fff;
    }
</style>
<style scoped>
</style>
